import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import { default as Old2005BlogPage, doNothingAnchor } from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—April 2005" />
	<Old2005BlogPage>
		<h2>April 2005</h2>




		<h3 className="blogdate">
		Tuesday, April 26, 2005
		</h3>






		<h4 className="blogitemtitle">
		Farewell to Eddie Bo Dean's!
		</h4>





			<div className="blogitembody">
			Last night was my last night at Eddie Bo Dean's, my last attendance of Rebecca Wittwer's Open Mic! Last night was my last night... I am a grammatical master. I am running on 2 hours of sleep so forget about it.<br /><br />What can I say about last night? I cannot stress how excellent everyone made me feel, with drinks and inspiring words and conversations, great music, a most wonderful "good-bye" card, and party hats and leis with balloons and decorations!<br /><br />Again, I'm very tired right now, so prepare yourself for a load of fluff. But it's heartfelt fluff! I believe that energy flows to and from you, such that what you output will be returned to you if you surround yourself with great people. Last night it was exceptionally obvious that I have surrounded myself with amazing people, and that these people will remember me when I am away in Australia. I have been inspired by them, I will miss them, and I will fondly remember them and this incredible alignment of spirits and talent that has been "Spring of 2005". My heart tells me that I have become part of some fulfilling friendships that will withstand distance and time!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:11 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Wednesday, April 20, 2005
		</h3>






		<h4 className="blogitemtitle">
		New live performance pics
		</h4>





			<div className="blogitembody">
			Just a quick post to say there are new pics up!  Thanks to Dave Simpson!  These are pics from Eddie Bo Dean's and Jackdaw's Pub in Calgary (April).<br /><br />Links:<br /><a href="/" onClick={doNothingAnchor}>http://www.davesimpsonmusic.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:22 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Tuesday, April 19, 2005
		</h3>






		<h4 className="blogitemtitle">
		More on the Ship & Anchor songwriting contest
		</h4>





			<div className="blogitembody">
			Here is the latest info from the Ship & Anchor:<br /><br /><a href="http://www.calgaryfolkfest.com/users/folder.asp?FolderID=2505">http://www.calgaryfolkfest.com/users/folder.asp?FolderID=2505</a><br /><br />This is still very exciting for me!  I believe my friend Rebecca Wittwer is going to perform my song for me on May 7 at the Ship, possibly accompanied by Greg Cockerill?  As you can see, nothing is concrete yet, but I must say that I really appreciate that Rebecca has offered to help me.  I would like to publically announce that Rebecca is a fantastic friend... and if you weren't at Karma on Sat night to see her and Dave Simpson perform, then you really missed out.  Really you did, but don't worry...  she will perform again soon so you get another chance!  Rebecca, if you are reading this, please comment to promote your next gig(s).  Yes, do it.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:41 PM &nbsp;

			</div>











		<h4 className="blogitemtitle">
		Forced myself to Eddie Bo Dean's last night
		</h4>





			<div className="blogitembody">
			I was so tired from the weekend and week prior that I had to force myself to attend Rebecca's Open Mic... now how sad is that?  Definitely glad I went as seeing my new friends gave me a little extra energy!  It was cool to see new faces get up and play last night, I hope this Open Mic keeps rocking on for some time to come.<br /><br />Greg played a completely original set last night which was very cool - his home-brewed songs are very reminiscent of a Bruce Springsteen unplugged.  Nathan's original song, which I believe is called "Broken Machine" (anyone want to correct me?), has a melody and tempo to it that is really growing on me.  Josh got up and did some proper-good covers of 800 Prospect and Ghosts of Modern Man tunes.  Rebecca changed her set up and played some great songs which I don't always here, including originals and "Wild Horses" by the Stones.  Dave also played a couple tunes that I was foggy on which I really enjoyed.  I am surprised I remember all of this... I was almost sleeping by the end of the night -  I was worn out.<br /><br />I did manage to pull of some songs myself:<br /><br />The Tragically Hip - Bobcaygeon<br />Stone Temple Pilots - Plush<br />The Tea Party - Oceans<br />Jesse Rivest - Mesmerize Me<br /><br />I had difficulty remembering the lyrics to my song (booo) and my fingers weren't up to the challenge on guitar - but I have learned that you can't be ON IT every time...  sometimes you just get by.  Overall, people still really enjoyed what I played!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:39 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Monday, April 18, 2005
		</h3>






		<h4 className="blogitemtitle">
		Rebecca Wittwer with Dave Simpson at Karma, April 16
		</h4>





			<div className="blogitembody">
			I had fun last night, here's what I wrote in my journal when I wasn't bouncing around the room with Dave's camera.<br /><br /><em>The house is packed immediately; the lights are low with candles on the tables creating a very warm atmosphere.  Speaking of warm, it's a beautiful spring evening in Calgary and Karma's windows are open so that the OVERLOW (yes, it's that packed) can clearly hear the show.  I wonder if Karma has seen it this packed in 2005?  Well, it's packed, and I see people dropping 5, 10, and 20 dollar bills in the donation box!</em><br /><br /><em>Dave warmed up quickly, responding to the excellent energy from the crowd, and rocked everyone with and upbeat set.  Favorites such as "White Shoes (Perfect)", "Tracks of My Tears", and "Man in the Mirror" appeared.  I think Dave played 10 or 11 songs and passed the reigns to Rebecca, who shocked the crowd with "Dark and Stormy Night"... every one went silent!  Rebecca made new fans instantly.  Her set was very intimate and warm; her voice is amazing!  Songs included "Roy", "Better Suited", and "7 Devils Wayside", plus that incredible Alicia Keys song which I believe is called "Aint Got You".  By the way, the sound in the house was excellent, thanks to Josh Gwilliam...  No offense to Mike Robinson, but Josh has it dialed!  The night finished with Dave and Rebecca teaming up and harmonizing on "Wonderwall" and "Got You Where I Want You".</em>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 3:35 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Friday, April 15, 2005
		</h3>






		<h4 className="blogitemtitle">
		Yes, that is a gold chain around my neck
		</h4>





			<div className="blogitembody">
			Okay, a few people have voiced the opinion that the picture at the front of my website should be replaced with the following:<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20050415/jesse.jpg"
			alt="Jesse Rivest looking 70's"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={410}
			/>
			<br /><br />
			Really? I like this new pic, but I am quite partial to the one at the front of my site. I think I'll just post this one here and so you can have a giggle at my nice 70's shirt and gold chain!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:46 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Thursday, April 14, 2005
		</h3>






		<h4 className="blogitemtitle">
		Get together at Jackdaw's Pub
		</h4>





			<div className="blogitembody">
			Just got home from Jackdaw's Pub, where Sheri and Nate host an open mic!  Wasn't a very busy night, but there was great music played, regardless.  I got some pics of Dave and Rebecca playing together (and seperate), they both rocked as usual.  Both Dave and Rebecca are tremendous actually.  Greg and I did a couple Blue Rodeo songs together - I gotta say I think we do Hasn't Hit Me Yet together very well!  I tried to help him with "Lost Together" and I sorta pulled it off.<br /><br />I played some of my songs:  "Deadbeat Blues" and "Crazy French Girl", plus Lester Quitzau's "Time Takes Time".  Dave helped out and played harmonica on "Time Takes Time"!  Oh, and Greg played "Jesse's Girl" again by Rick Springfield... awesome!  Greg, you rock.<br /><br />Dave, thanks so much for the ride home, you have no idea how much I appreciate it, I know its a simple thing but its great.  However, I missed hearing Nate and Sheri's final set...  Nate invited me down to Ceili's on Tuesday night where they play, so I will get to hear more of their songs.  Nate said I could play some tunes that night, too!  I need to listen to their tunes because I believe there is one or two that I like and will want to cover.  Actually, Nate and I might do a trade where I cover one of his songs and he covers "Deadbeat Blues" for me on May 7 at the Ship & Anchor.   More on that later.<br /><br />One more thing... there is a cool fellow named Ricardo at Jackdaw's, and he has a great sense of rhythm and some very cool, slow-style original songs that you might like.  So go check out Jackdaw's on a Wed night, for Ricardo, but also because it is a cool atmosphere and Sheri and Nate are super great!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:41 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Tuesday, April 12, 2005
		</h3>






		<h4 className="blogitemtitle">
		Sweet and Sour - Ship & Anchor Songwriting Contest
		</h4>





			<div className="blogitembody">
			I just received notification today that my song "Deadbeat Blues" has been selected for a live performance in the annual Ship &amp; Anchor Songwriting Contest!!!!!! It's the semi-finals (Best Newcomer category) where my song competes with upto 15 other songs. Here are some details:<br /><br /><a href="http://www.calgaryfolkfest.com/users/folder.asp?FolderID=2505">http://www.calgaryfolkfest.com/users/folder.asp?FolderID=2505</a><br /><br />How sweet is that? Pretty fucking sweet! Now here's the sour... the live performances occur on May 7 (Best Newcomer).... and I'll be in Australia at that time. But I just found out that I can have somebody else perform my song for me.... so... anybody want to help me out? You can use the following info to listen to the song:<br /><br />link: <a href="/" onClick={doNothingAnchor}>Deadbeat Blues</a><br />username: songs<br />password: singsing<br /><br />I am overjoyed that my song was selected... they receive quite a few submissions and this contest is one of Calgary's most popular songwriting contests! I wish I could be here to play it myself but I am already quite financially committed to my trip to Australia. I have made some great musical friends and I'm hoping one of them will feel comfortable with learning my song and playing it for me. However, I have no expectation of advancing to the final and there is no pressure on any friend that wants to help me out. It's all cool... and worst case scenario I can ask the host of the contest to perform it for me.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:44 PM &nbsp;

			</div>











		<h4 className="blogitemtitle">
		Excellent Energy at Eddie Bo Dean's
		</h4>





			<div className="blogitembody">
			Last night wasn't very busy at Eddie Bo Dean's, in a sense that mostly music people were there!  Maybe we scared away all the non-music crowd during prior Sunday nights?  I dunno.  I gotta say, there was an excellent energy last night in the house and I think everyone had fun!<br /><br />Greg Cockerill kicked ass with The Boss and U2 and The Tragically Hip, and Dave Simpson definitely was on his game with some originals and some sweet sweet covers... like "Tracks of My Tears", yes.  A new fellow Brad was feeling pretty skilled on the guitar with a few John Mayer tunes, and Nathan ripped out "Disarm" by Smashing Pumpkins, as well as an original tune which is growing on me... I forget what it is titled (sorry).  Kalee writes really good songs on guitar, which is cool because he is mostly a fantastic funky bass player and singer, but then he whips out cool original songs on guitar.  And LET'S NOT FORGET to mention the most incredible singing of Rebecca Wittwer!!!!<br /><br />I felt on-the-ball last night, too, and started with Blue Rodeo's "Hasn't Hit Me Yet", which Greg provided backup vocals on... awesome!  Thanks Greg, it was sweet!  Thanks to Dave and Rebecca for pulling requests like "Dragon and Kitty" (my song), and Xavier Rudd's "Solace Amongst The Sin".  Also, I dedicated The Tea Party's "Gone" to Erin since it her birthday week (?!?), and Rebecca came and helped me with "She Talks to Angels" by the Black Crowes.  Last night rocked, actually.<br /><br />Are you reading this and saying, "what is this Eddie Bo Dean's place and why do I not go there on Sunday nights to see all these musicians?"  If you are, then stop being silly and come on April 17 or 24!  Those are my last two nights before I head to Australia!  But in general, this should be said:  There are many open mics in the city of Calgary, but Rebecca Wittwer's Open Mic at Eddie Bo Dean's has the best ratio for talented and exciting musicians (to not-so-interesting musicians... it's a ratio, get it)!  I promise!<br /><br />If I forgot something really exciting, then someone who was there should post a comment on this post.  Yes.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 3:54 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Tuesday, April 05, 2005
		</h3>






		<h4 className="blogitemtitle">
		Music is healing, so are friends
		</h4>





			<div className="blogitembody">
			I gotta say I've been down lately with work and a few other things on my mind.  But I pulled it together for Saturday and cooked dinner for some long-time friends from Kelowna.  It sure was fun having them over!  And last night I went to Eddie Bo Dean's again and listened to (and played) music, which is also healing.<br /><br />Thanks to Dave Simpson for letting me get up to play accompanying guitar on "All Alone", I hope I got it right, it's a good song dude.  Thanks to Rebecca and Josh for being awesome in many, many ways.  Thanks to Greg for sharing my standpoint that Sunday night has become the best night of the week.  Thanks to Erin for making me play "Sweet Euphoria" again (Chris Cornell) and for being fun and cool.  Thanks to Joe and Sheri for accompanying me on "She Talks to Angels"... very cool!  Also thanks to Eddie Bo Dean's for letting Rebecca host the best open mic in Calgary.<br /><br />Back to work and a few things on my mind.<br /><br />Oh, by the way, Dave put some pictures up on his site which make me smile.<br /><br />Links:<br /><a href="/" onClick={doNothingAnchor}>http://davesimpsonmusic.com/v-web/gallery/album02</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:35 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Sunday, April 03, 2005
		</h3>






		<h4 className="blogitemtitle">
		WIL at Broken City - April 1, 2005
		</h4>





			<div className="blogitembody">
			WOW<br /><br />WIL has outstanding energy and rhythm on stage; he is a MUST-SEE performer, especially when he has Pat Stewart drumming for him.  These guys were so tight together, I think they were born together in seperate hospitals.  Plus WIL has a great voice and stage presence.  I wonder if WIL is suposed to be all capital letters?  I dunno...<br /><br />Thanks to Rebecca, Josh, Dave, Erin, Joe, and Dorothea for being there with me as I lost my "WIL virginity"!<br /><br />Links:<br /><a href="http://www.ibreakstrings.com/">http://www.ibreakstrings.com/</a><br /><a href="http://www.brokencity.ca/">http://www.brokencity.ca/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 10:29 AM &nbsp;

			</div>




		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
